import React, { useEffect, useState, useContext } from "react";

import userService from "../services/userService";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const { user, setUser } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();


  useEffect(() => {
    const fetchProfile = async () => {
      try {
        // const data = await userService.getProfile();
        const data = {};
        setUser(data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      } finally {
        setLoading(false);
      }
    };


    if (!user) {
      // fetchProfile();
    } else {
      setLoading(false);
    }
  }, [user, setUser]);

  if (loading) {
    return <p>Loading user info...</p>;
  }

  return (
    <div className="row">
      <div className="col-lg-8 d-flex align-items-strech">
        <div className="card w-100">
          <div className="card-body flex flex-col gap-6">
            <h6 className="text-lg text-gray-500 font-semibold">      <span>Profile Information</span></h6>
            <div className="card">
              <div className="card-body flex flex-wrap gap-3">
                {user ? (
                  <div className="profile-info">
                    <p><strong>Username:</strong> {user.user_name}</p>
                    <p><strong>Email:</strong> {user.email}</p>
                    <p><strong>First Name:</strong> {user.first_name}</p>
                    <p><strong>Last Name:</strong> {user.last_name}</p>
                    <ul>
                      <li>Magazines: </li>
                      {user.magazines.forEach(element => { <>{element['magazine_name']}</> })}
                    </ul>
                    <p><strong>Magazine:</strong> {user.magazines[0].magazine_name}</p>
                    <p><strong>Status:</strong> {(user.is_active === '1') ? 'Active' : 'In active'}</p>
                    <div className="changepassword_view">
                      <button className="btn btn-sm btn-primary" onClick={() => navigate(`/profile/${user.id}/change-password`)}>
                        Change Password
                      </button>
                    </div>
                  </div>
                ) : (
                  <p>No profile found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
